import Vue from 'vue'
import Router from 'vue-router'
import Routers from './routerConfig'

Vue.use(Router)

export default new Router({
    routes:Routers
})